import { withCompInfo } from '@wix/editor-elements-integrations'
import type { CompInfo } from '@wix/thunderbolt-becky-root'
import { SectionCss } from './Section'
import {
	getFillLayersColorsVars,
	getFillLayersCSSVars,
	getFillLayersMediaVars,
} from '../../core/mappers/FillLayers/FillLayers.utils'
import {
	getShapeDividersCSSVars,
	getShapeDividersResponsiveCSSVars,
} from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import { getCompDesignPerVariant } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'

const getShouldUseCssPerVariantMapperForDividers = (experiments: CompInfo['experiments']) =>
	experiments['specs.thunderbolt.responsiveShapeDividers'] ||
	experiments['specs.thunderbolt.responsiveShapeDividersPublic']

const getShouldUseCssPerVariantMapperForBgColor = (experiments: CompInfo['experiments']) =>
	experiments['specs.thunderbolt.backgroundColorPerBreakpoint']

export const css = withCompInfo<SectionCss, any>()(
	[
		'compId',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'hasResponsiveLayout',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compId,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		hasResponsiveLayout,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const compDesignPerVariantMap = getCompDesignPerVariant(compDesign)
		const defaultDesign = compDesignPerVariantMap['']
		const backgroundMedia = defaultDesign?.background
		const hasNoColorLayers = !backgroundMedia?.colorLayers

		const shouldUseCssMapperForDividers = !getShouldUseCssPerVariantMapperForDividers(experiments)
		const shouldUseCssMapperForBgColor = !getShouldUseCssPerVariantMapperForBgColor(experiments)
		const getBackgroundCSSVars =
			shouldUseCssMapperForBgColor || hasNoColorLayers ? getFillLayersCSSVars : getFillLayersMediaVars

		const fillLayersCSSVars = backgroundMedia
			? getBackgroundCSSVars({
					animations,
					backgroundMedia,
					compDesign,
					compProps,
					compId,
					experiments,
					isMobileView,
					isNonAdaptiveMobile,
					siteColors,
					viewMode,
			  })
			: {}

		const shapeDividersCSSVars = shouldUseCssMapperForDividers
			? getShapeDividersCSSVars({ compId, hasResponsiveLayout, isMobileView, compDesign, colorsMap: siteColors })
			: {}

		return {
			...fillLayersCSSVars,
			...shapeDividersCSSVars,
		} as SectionCss
	}
)

export const designCss = withCompInfo<any, any>()(
	['compId', 'compDesign', 'experiments', 'siteColors'],
	({ compId, compDesign, experiments, siteColors }) => {
		const shouldUseCssPerVariantMapperForDividers = getShouldUseCssPerVariantMapperForDividers(experiments)
		const shouldUseCssPerVariantMapperForBgColor = getShouldUseCssPerVariantMapperForBgColor(experiments)

		const backgroundMedia = compDesign?.background
		const hasColorLayers = backgroundMedia?.colorLayers
		const colorLayers =
			shouldUseCssPerVariantMapperForBgColor && hasColorLayers
				? getFillLayersColorsVars({
						siteColors,
						backgroundMedia,
				  })
				: {}

		const shapeDividersCSSVars = shouldUseCssPerVariantMapperForDividers
			? getShapeDividersResponsiveCSSVars({
					compId,
					compDesign,
					colorsMap: siteColors,
			  })
			: {}

		if (shouldUseCssPerVariantMapperForDividers || shouldUseCssPerVariantMapperForBgColor) {
			return {
				...colorLayers,
				...shapeDividersCSSVars,
			}
		}
	}
)
